import { getApps, initializeApp, type FirebaseApp } from 'firebase/app';
import { getAuth, type Auth } from 'firebase/auth';
import { getFirestore, type Firestore } from 'firebase/firestore';
import { resolveFirebaseConfig } from '../config/firebase.config';
import { MVP_DEMO_OFFLINE } from '../config/mvp-demo.config';

let firebaseApp: FirebaseApp | undefined;
let firebaseAuth: Auth | undefined;
let firestore: Firestore | undefined;

function ensureFirebaseApp(): FirebaseApp {
  if (MVP_DEMO_OFFLINE) {
    throw new Error('Firebase no se usa en modo demo offline.');
  }
  if (!firebaseApp) {
    const config = resolveFirebaseConfig();
    firebaseApp =
      getApps().length > 0 ? getApps()[0]! : initializeApp(config);
  }
  return firebaseApp;
}

/** Firebase Auth (mismo proyecto que la app móvil). */
export function getFirebaseAuth(): Auth {
  if (!firebaseAuth) {
    firebaseAuth = getAuth(ensureFirebaseApp());
  }
  return firebaseAuth;
}

/** Firestore (`users/{uid}` — perfiles + suscripción que escribe la app móvil). */
export function getFirebaseFirestore(): Firestore {
  if (!firestore) {
    firestore = getFirestore(ensureFirebaseApp());
  }
  return firestore;
}
